import React from 'react';

import { RouteObject } from 'react-router-dom';

import { ActFormView } from '@/pages/MeteringPointActDetails/components/MeteringPointActDetailsNavigation';

const Information = React.lazy(
  () => import('@/pages/MeteringPointActDetails/views/Information'),
);

const Devices = React.lazy(
  () => import('@/pages/MeteringPointActDetails/views/Devices'),
);

const Equipments = React.lazy(
  () => import('@/pages/MeteringPointActDetails/views/Equipments'),
);

const Seals = React.lazy(
  () => import('@/pages/MeteringPointActDetails/views/Seals'),
);

export const meteringPointActDetailsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Information />,
  },
  {
    path: ActFormView.Devices,
    element: <Devices />,
  },
  {
    path: ActFormView.Equipments,
    element: <Equipments />,
  },
  {
    path: ActFormView.Seals,
    element: <Seals />,
  },
];
